import * as React from 'react';
import { PrimaryActionComponentFactory } from 'app/area/case-report/case-listing/types';
import { CasePermissions } from 'app/types-shared';

import styles from './case-listing-tile.scss';
import { Field } from 'app/infrastructure/ui/renderer';
import { InitialUiEngineProps } from 'app/infrastructure/ui/types-uischema';

export interface CaseListingTileProps {
  caseNumber: number;
  primaryActionComponentFactory?: PrimaryActionComponentFactory;
  permissions: CasePermissions;
  initialUiEngineProps: InitialUiEngineProps;
}

export function CaseListingTile({
  caseNumber,
  permissions,
  primaryActionComponentFactory: PrimaryAction,
  initialUiEngineProps
}: CaseListingTileProps) {
  
  const content = PrimaryAction ?
    (
      <>
        <div className={styles.left}>
          <Field {...initialUiEngineProps} />
        </div>
        <div className={styles.right}>
          <PrimaryAction 
            caseId={caseNumber} 
            permissions={permissions} />
        </div>
      </>
    ) : <Field {...initialUiEngineProps} />;

  return (
    <div className={styles.caseListingTile}>
      {content}
    </div>
  );
}
